import { render, staticRenderFns } from "./LabelSvg.vue?vue&type=template&id=045be1a9&scoped=true&"
import script from "./LabelSvg.vue?vue&type=script&lang=ts&"
export * from "./LabelSvg.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./LabelSvg.vue?vue&type=style&index=0&id=045be1a9&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "045be1a9",
  null
  ,true
)

export default component.exports